import { supabase, isCloudMode } from '../supabase.ts';
import type { User, Session } from '@supabase/supabase-js';

export const authStore = $state({
  user:        null as User | null,
  session:     null as Session | null,
  loading:     true,
  isCloudMode,
});

export async function initAuth() {
  if (!isCloudMode || !supabase) {
    authStore.loading = false;
    return;
  }

  // Get initial session
  const { data: { session } } = await supabase.auth.getSession();
  authStore.session = session;
  authStore.user    = session?.user ?? null;
  authStore.loading = false;

  // Listen for auth changes
  supabase.auth.onAuthStateChange((_event, session) => {
    authStore.session = session;
    authStore.user    = session?.user ?? null;
  });
}

export async function signInWithGitHub() {
  if (!supabase) return;
  await supabase.auth.signInWithOAuth({
    provider: 'github',
    options: { redirectTo: window.location.origin },
  });
}

export async function signInWithGoogle() {
  if (!supabase) return;
  await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: { redirectTo: window.location.origin },
  });
}

export async function signInWithEmail(email: string) {
  if (!supabase) return { error: null };
  return supabase.auth.signInWithOtp({
    email,
    options: { emailRedirectTo: window.location.origin },
  });
}

export async function signOut() {
  if (!supabase) return;
  await supabase.auth.signOut();
}
